import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, getglobaldata, NumConv, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, GetDesitRound, GetRound } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, rerendergrid } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import { render } from 'react-dom';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const ProdPurchaseV = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", MEI: "1", TOTAL: "T1", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl" }
    //const G_id = { BASE: "0", SSR: "1", SSH: "2", SSU: "3", SNS: "4", IMAGE: "pic", FILE: "file", NB: "nb", PL: "pl" }

    const SSR = ["100", "101", "102", "103", "104"];
    const SSH = ["110", "111", "112", "113", "114", "115"];
    const SSU = ["120", "121", "122", "123", "124", "125"];
    const SNS = ["130", "131", "132", "133", "134", "135"];

    const primarykeys = ["SSR_DENNO", "SSRM_DENNO"];
    const formid = getformid("ProdPurchaseV", props.location.search);
    const controller = getcontroller("ProdPurchaseV", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formListOption = useSelector(state => state.form.listoption);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const baseref = useRef();
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    // const CELLTYPE = CellType();

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const listoptionRef = useRef('0');        //0:原材料 1:附属 2:副資材

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    function OptID() {
        switch (listoptionRef.current) {
            case "0": return G_id.SSR;
            case "1": return G_id.SSH;
            case "2": return G_id.SSU;
            case "3": return G_id.SSU;
        }
    }
    const actionurl = {
        "getlist": "ProdPurchaseV/GetListData",
    }

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
    ];

    const navmenu = [
        { status: "ENTRY FORM", menuid: "withdraw", icon: "cancel", label: "申請解除" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "print1", icon: "print", label: "製商品仕入帳票発行" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "print1", icon: "print", label: "製商品仕入帳票発行" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    //項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                        let t = data.colinfo.find(e => e.logpid === "T" + panel.id)
                        if (!isEmpty(t)) {
                            //TOTAL用REF作成
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panel.id, type: t.type, index: idx });
                            idx++;
                        }
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            rerender();
        }
        // if (formstatus === "VIEW") {
        //     var type = baseref.current.ListType();
        //     if (type === "0" || type === "1") {
        //         var newmenu = navmenu.filter(e => e.menuid !== 'print2' && e.menuid !== 'print3' && e.menuid !== 'print4');
        //         newmenu.push({ status: "VIEW", menuid: "sep" });
        //         newmenu.push({ status: "VIEW", menuid: "datatree", icon: "account_tree", label: "Data Tree" });
        //         baseref.current?.ChangeNavmenu(newmenu);
        //     }
        //     if (type === "2" || type === "3") baseref.current?.ChangeNavmenu(navmenu.filter(e => e.menuid !== 'print1' && e.menuid !== 'print3' && e.menuid !== 'print4'));
        //     if (type === "4" || type === "5") baseref.current?.ChangeNavmenu(navmenu.filter(e => e.menuid !== 'print1' && e.menuid !== 'print2'));

        // }
    }, [formstatus]);

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function Show(data, pushcode, listoption) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (!isEmpty(listoption)) listoptionRef.current = listoption;
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    function kikakueColumnName(mode, value) {
        switch (value) {
            case "1":
                return mode === 0 ? "規格長(m)" : "規格巾(m)";
            case "2":
                return mode === 0 ? "規格長(yd)" : "規格巾(yd)";
            default:
                return mode === 0 ? "規格長" : "規格巾";
        }
    }

    function changeBaseColumnName(columnid, columnnm) {
        const updateColumns = (fields) => {
            if (isEmpty(fields)) return fields;
            const idx = fields.findIndex(e => e.columnid === columnid);
            if (idx === -1 || fields[idx].columnnm === columnnm) return fields;
            const newfields = DeepCopy(fields);
            newfields[idx].columnnm = columnnm;
            return newfields;
        };
        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }

    function setKikakueColumnName(value) {
        // changeBaseColumnName("KHD_KIKAKUE", kikakueColumnName(0, value));
        // changeBaseColumnName("KHD_KIKAKU", kikakueColumnName(1, value));
    }
    function setSyukasakiMaster(value) {
        var dataid = value === "1" ? "V_SUPPLIER" : "V_FACTORY";
        const updateColumns = (fields) => {
            if (isEmpty(fields)) return fields;
            const idx = fields.findIndex(e => e.columnid === "FRH_SYUKASAKICD");
            if (idx === -1 || fields[idx].dataid === dataid) return fields;
            const newfields = DeepCopy(fields);
            newfields[idx].dataid = dataid;
            return newfields;
        };
        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(formListOption) || formListOption.length === 0) return target;
        let newdata = { ...target };
        formListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
                return;
            }
            if (option.headerfix === 1) {
                newdata[option.columnid] = listoptionRef.current;
            }
        });
        return newdata;
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
        if (action === "print1") {  //製商品仕入帳票発行
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                let param = baseref.current?.GetSelectrowdata();
                if (param.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('SeihinSiireReport/Generate', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
    }
    function Save(finallycallback, nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        SetPLData();    //PL行データをentrydataRefにセット
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i].id);
        }
        const paramdata = {
            "type": listoptionRef.current,
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }
        storeRowData();
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "ProdPurchaseV/UpdateEntry" : "ProdPurchaseV/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if (pkey !== "") entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("forms", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください", "　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            type: listoptionRef.current,
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("ProdPurchaseV/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('ProdPurchaseV/GetData', { "code": code, "colinfo": columninfo, "controller": controller, type: listoptionRef.current },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            const beforeData = entrydataRef.current;
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = keepListOptionValue(data.data, beforeData);

                            //行データ
                            for (let i = 0; i < gridlist.length; i++) {
                                if (!isEmpty(data.detail[gridlist[i].type])) {
                                    SetGridData({ id: gridlist[i].id }, data.detail[gridlist[i].type]);
                                    if (existTotal(gridlist[i].id)) {
                                        //合計セット
                                        SetTotalData(gridlist[i].id, data.detail[gridlist[i].type], true);
                                    }
                                }
                            }
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            initLoad();

                            getSuppliersInfo(0);

                            showpanel('0', '104', (data.data['SSR_SHOKUFLG'] === '1'));

                            reCalc();

                            // fileRef.current = data.files;
                            // imageRef.current = data.images;
                            // dispatch(setimagelist(data.images));
                            rerender();
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    //入力フィールドクリア
    function clearform(newform) {
        const beforeData = entrydataRef.current;
        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
        // if (listoptionRef.current === "0") {
        //     setKikakueColumnName(entrydataRef.current["KHD_HACHUTANI"]);
        // }
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            init();
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
                        // if (listoptionRef.current === "0") {
                        //     setKikakueColumnName(entrydataRef.current["KHD_HACHUTANI"]);
                        // }

                        rerender();
                    },
                }, true
            )
        }
    }
    //
    function ChangeRowValue(params, panel) {

        let rowdata = GridData(panel).find(e => e.rowid === params.data.rowid);

        if (params.column.colId === "SSRM_OPPICD" && !isEmpty(rowdata)) {
            getMPdtInfo(rowdata, rowdata["SSRM_OPPICD"], null);
        }
        if (params.column.colId === "PDT_SYOHINCD" && !isEmpty(rowdata)) {
            getMPdtInfo(rowdata, null, rowdata["PDT_SYOHINCD"]);
        }
        if (params.column.colId === "SSRM_COLORCD" && !isEmpty(rowdata)) {
            getMPdtcInfo(rowdata);
        }
        if (params.column.colId === "SSRM_SIZECD" && !isEmpty(rowdata)) {
            getMPdtcInfo(rowdata);
        }
        if (params.column.colId === "SSRM_SIIRESU" && !isEmpty(rowdata)) {
            RowDataChanged(panel);
        }
        if (params.column.colId === "SSRM_TANKA" && !isEmpty(rowdata)) {
            // 外貨単価を取得
            rowdata["SSRM_TANKAF"] = ExchangePrice(params.newValue, 1);

            RowDataChanged(panel);
        }
        if (params.column.colId === "SSRM_TANKAF" && !isEmpty(rowdata)) {
            // 円単価を取得
            rowdata["SSRM_TANKA"] = ExchangePrice(params.newValue, 0);

            RowDataChanged(panel);
        }
        if (params.column.colId === "SSRM_URITANKA" && !isEmpty(rowdata)) {
        }
        // if (listoptionRef.current === "0") {
        //     if (params.column.colDef.colinfo.datatype !== CELLTYPE.NUM) {
        //         storeRowData(panel);
        //         if (params.column.colId === "KHDM_COLORKEY") {
        //             GetZaiColorInfo(params.newValue, params.data.rowid);
        //         }
        //         return;
        //     }
        //     var rowdata = GridData(panel).find(e => e.rowid === params.data.rowid);
        //     if (params.column.colId === "KHDM_TANSU" && !isEmpty(rowdata)) {
        //         //M=反数×規格長
        //         let value = NumConv(params.newValue) * NumConv(entrydataRef.current["KHD_KIKAKUE"]);
        //         rowdata["KHDM_MATERSU"] = GetDesitRound(value, 1, 2);   //四捨五入
        //     }
        //     if (params.column.colId === "KHDM_MATERSU" && !isEmpty(rowdata)) {
        //         //反数=M÷規格長
        //         let value = NumConv(params.newValue) / NumConv(entrydataRef.current["KHD_KIKAKUE"]);
        //         rowdata["KHDM_TANSU"] = GetDesitRound(value, 2, 1);      //切り上げ
        //     }
        //     if (entrydataRef.current["KHD_TSUKATANI"] !== "JPY" && params.column.colId === "KHDM_TANKA" && !isEmpty(rowdata)) {
        //         //外貨単価を取得
        //         rowdata["KHDM_TANKAF"] = ExchangePrice(params.newValue, 1);
        //     }
        //     if (entrydataRef.current["KHD_TSUKATANI"] !== "JPY" && params.column.colId === "KHDM_TANKAF" && !isEmpty(rowdata)) {
        //         //円単価を取得
        //         rowdata["KHDM_TANKA"] = ExchangePrice(params.newValue, 0);
        //     }
        //     RowDataChanged(panel);
        // } else {
        //     if (params.column.colDef.colinfo.datatype !== CELLTYPE.NUM) {
        //         storeRowData(panel);
        //         if (params.column.colId === "FRHM_ZAIHINBAN") {
        //             GetFuzokuInfo(params.newValue, params.data.rowid);
        //             return;
        //         }
        //         if (params.column.colId === "FRHM_ZAICOLORCD") {
        //             GetFuzokuColInfo(params.newValue, params.data.rowid);
        //             return;
        //         }
        //         return;
        //     }
        //     var rowdata = GridData(panel).find(e => e.rowid === params.data.rowid);
        //     if (entrydataRef.current["FRH_TSUKATANI"] !== "JPY" && params.column.colId === "FRHM_TANKA" && !isEmpty(rowdata)) {
        //         //外貨単価を取得
        //         rowdata["FRHM_TANKAF"] = ExchangePrice(params.newValue, 1);
        //     }
        //     if (entrydataRef.current["FRH_TSUKATANI"] !== "JPY" && params.column.colId === "FRHM_TANKAF" && !isEmpty(rowdata)) {
        //         //円単価を取得
        //         rowdata["FRHM_TANKA"] = ExchangePrice(params.newValue, 0);
        //     }
        //     RowDataChanged(panel);
        // }
    }
    function RowValueChanged(colid, targets, panel) {
        // RowDataChanged(panel);

        let rowdata = GridData(panel).find(e => e.rowid === targets.data.rowid);

        // if (params.column.colId === "SSRM_OPPICD" && !isEmpty(rowdata)) {
        //     getMPdtInfo(rowdata, rowdata["SSRM_OPPICD"], null);
        // }
        // if (params.column.colId === "PDT_SYOHINCD" && !isEmpty(rowdata)) {
        //     getMPdtInfo(rowdata, null, rowdata["PDT_SYOHINCD"]);
        // }
        // if (colid === "SSRM_COLORCD") {
        //     getMPdtcInfo(1);
        // }
        // if (params.column.colId === "SSRM_COLORCD" && !isEmpty(rowdata)) {
        //     getMPdtcInfo(rowdata);
        // }
        // if (params.column.colId === "SSRM_SIZECD" && !isEmpty(rowdata)) {
        //     getMPdtcInfo(rowdata);
        // }
    }
    //Grid Row Data Change
    function RowDataChanged(panel) {
        if (isEmpty(GridApi(panel))) {
            return;
        }
        let data = GridData(panel);
        if (isEmpty(data)) {
            data = [];
        }
        for (let i = 0; i < data.length; i++) {
            let qty = NumConv(data[i]["SSRM_SIIRESU"]);

            if (entrydataRef.current["SSR_TSUKATANI"] !== "JPY") {
                data[i]["SSRM_SIIREKINGAKU"] = calcAmount(qty, data[i]["SSRM_TANKA"], 0);
                data[i]["SSRM_SIIREKINGAKUF"] = calcAmount(qty, data[i]["SSRM_TANKAF"], 1);
            } else {
                data[i]["SSRM_SIIREKINGAKU"] = calcAmount(qty, data[i]["SSRM_TANKA"], 0);
                data[i]["SSRM_TANKAF"] = 0;
                data[i]["SSRM_SIIREKINGAKUF"] = 0;
            }
            data[i]["SSRM_KINGAKUZ"] = getKingakuZ(data[i]["SSRM_SIIREKINGAKU"], data[i]);
        }
        fnc.current.rerenderGrid(panel.id);

        reCalc();
        // if (existTotal(panel.id)) {
        //     SetTotalData(panel.id, data);
        // }
    }
    function SetTotalData(id, data) {
        // if (id === "1") {
        //     let total = { qty: 0, amt: 0, curamt: 0 };
        //     for (let i = 0; i < data.length; i++) {
        //         total.qty += NumConv(data[i]["KHDM_MATERSU"]);
        //         total.amt += NumConv(data[i]["KHDM_HACHUKINGAKU"]);
        //         total.curamt += NumConv(data[i]["KHDM_HACHUKINGAKUF"]);
        //     }
        //     let rowNode = GridApi("T" + id).getRowNode("TOTAL");
        //     if (!isEmpty(rowNode)) {
        //         rowNode.setDataValue('KHD_QTY_T', total.qty);
        //         rowNode.setDataValue('KHD_AMT_T', total.amt);
        //         rowNode.setDataValue('KHD_FAMT_T', total.curamt);
        //     }
        // } else {
        //     let total = { qty: 0, amt: 0, curamt: 0 };
        //     for (let i = 0; i < data.length; i++) {
        //         total.qty += NumConv(data[i]["FRHM_SURYO"]);
        //         total.amt += NumConv(data[i]["FRHM_KINGAKU"]);
        //         total.curamt += NumConv(data[i]["FRHM_KINGAKUF"]);
        //     }
        //     let rowNode = GridApi("T" + id).getRowNode("TOTAL");
        //     if (!isEmpty(rowNode)) {
        //         rowNode.setDataValue('FRH_QTY_T', total.qty);
        //         rowNode.setDataValue('FRH_AMT_T', total.amt);
        //         rowNode.setDataValue('FRH_FAMT_T', total.curamt);
        //     }
        // }
    }
    //金額計算
    function calcAmount(qty, price, mode) {
        var amt = NumConv(qty) * NumConv(price);
        if (mode === 0) {   //円
            return GetRound(amt, 0);
        } else {            //外貨
            return GetDesitRound(amt, 0, 2);
        }
    }
    //外貨→円、円→外貨変換
    function ExchangePrice(price, mode) {
        var rate = NumConv(entrydataRef.current["SSR_RATE"]);
        if (mode === 0) {   //外貨→円
            return GetRound(rate * price, 1);
        } else {            //円→外貨
            return GetDesitRound(price / rate, 1, 2);
        }
    }
    function getKingakuZ(kingaku, data) {
        let taxCd = NumConv(entrydataRef.current["SSR_TAXCD"]);
        let ioTaxKbn = data["PDT_CHODATUZEIKBN"];
        let taxRate = entrydataRef.current["ISUZ_ZEIRITU"];
        let zeiSyoriKbn = entrydataRef.current["TOR_SYOUHIZEISYORIKBN"];
        let roundType = NumConv(zeiSyoriKbn) - 1;
        if (roundType <= 0) {
            roundType = 1;
        }
        let result = 0;

        if (ioTaxKbn === "1" || ioTaxKbn === "2") {
            if (taxCd === "8") { // 外税
                result = kingaku;
            } else if (taxCd === "9") { // 内税
                const tax = kingaku / (1 + taxRate / 100) * taxRate / 100;

                result = kingaku - GetRound(tax, roundType);
            } else {
                result = kingaku;
            }
        } else {
            result = kingaku;
        }
        return result;
    }
    //外貨から円単価を再計算
    function RecalcExchange() {
        // var data = GridData(OptID());
        // if (isEmpty(data)) data = [];
        // for (let i = 0; i < data.length; i++) {
        //     //円単価＝外貨×レート
        //     var price = ExchangePrice(NumConv(data[i][listoptionRef.current === "0" ? "KHDM_TANKAF" : "FRHM_TANKAF"]), 0);
        //     data[i][listoptionRef.current === "0" ? "KHDM_TANKA" : "FRHM_TANKA"] = price;
        // }
        // RowDataChanged({ id: OptID() });
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        if (edit) {
            let data = entrydataRef.current;

            if (id === "SSR_SIIREKIND") {
                init()
            }
            if (id === "SSR_SIIREKIND" || id === "SSR_SYORIKIND") {
                setSanMotoDenKbnList()
            }
            if (id === "SSR_SANMOTODENKBN") {
                setSokoKbnList();

            }
            if (id === "SSR_SANSYODENNO") {
                let siireKind = data["SSR_SIIREKIND"];
                let syoriKind = data["SSR_SYORIKIND"];
                let sanMotoDenKbn = data["SSR_SANMOTODENKBN"];

                if (siireKind == "1" && sanMotoDenKbn == "1") {
                    getDShd(value);
                }
                if ((syoriKind == "03" || syoriKind == "04") && sanMotoDenKbn == "2") {
                    getDSsr(value);
                }
                if (siireKind == "1" && sanMotoDenKbn == "4") {
                    getWSsr(value);
                }
            }
            if (id === "SSR_SIIREBI") {
                getCurRate();
                getInbkNaibuBaibaiKakeritu();
                getIsuzZeiritu();
            }
            if (id === "SSR_KEIJYODATE") {
                getInbkNaibuBaibaiKakeritu();
            }
            if (id === "SSR_SIIREMOTO" || id === "SSR_KIKAMOTO") {
                getInbkNaibuBaibaiKakeritu();
            }
            if (id === "SSR_SIIRESAKICD") {
                getSuppliersInfo(1);
                getIsuzZeiritu();
            }

            changeEditable(id, value);
            // // 仕入種別
            // if (id === "SSR_SIIREKIND") {
            //     if (value === "0") {
            //         // 量産
            //     } else if (value === "1") {
            //         // サンプル
            //     }

            // }
        }
        // //var current = entrydataRef.current[id];
        // //if (current === value) return;
        // if (id === "KHD_HACHUTANI") {   //発注単位
        //     setKikakueColumnName(value);    //規格ラベル変更
        // }
        // if (edit) {
        //     if (id === "KHD_HACHUBI" || id === "FRH_HACYUBI") {     //発注日
        //         //外貨の場合レート取得
        //         if (entrydataRef.current[listoptionRef.current === "0" ? "KHD_TSUKATANI" : "FRH_TSUKATANI"] !== "JPY") {
        //             GetRate();
        //         }
        //     }
        //     if (id === "KHD_TSUKATANI" || id === "FRH_TSUKATANI") {   //通貨単位
        //         if (value !== "JPY") GetRate();
        //         else entrydataRef.current[listoptionRef.current === "0" ? "KHD_SHANAIRATE" : "FRH_RATE"] = 1;
        //     }
        //     if (id === "KHD_HACHUSAKICD" || id === "FRH_HACHUSAKICD") {  //発注先
        //         GetTorihikiInfo();
        //     }
        //     if (id === "KHD_HINBAN") {       //素材
        //         GetZairyoInfo();
        //     }
        //     if (id === "FRH_SYUKASAKIKBN") {    //出荷先区分
        //         setSyukasakiMaster(value);
        //         entrydataRef.current["FRH_SYUKASAKICD"] = "";
        //         fnc.current.entryrerender();
        //     }
        //     if (id === "FRH_SYUKASAKICD") {     //出荷先
        //         if (!isEmpty(value)) {
        //             GetSyukaInfo(value);
        //         }
        //     }
        // }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    //
    function getCurRate() {
        var data = {};
        data["curCode"] = entrydataRef.current["SSR_TSUKATANI"];
        data["rateBi"] = entrydataRef.current["SSR_SIIREBI"];
        data["imExpKbn"] = "1";
        data["rateKbn"] = "2";
        data["format"] = "F2";

        fnc.current.postaxios('TSICom/GetCurRate',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    entrydataRef.current["SSR_RATE"] = data.request;

                    fnc.current.entryrerender();
                    //単価再計算
                    //RecalcExchange();
                    reCalc();
                },
            },
            true
        )
    }
    //
    function getInbkNaibuBaibaiKakeritu() {
        var data = {};
        data["oppiCd"] = entrydataRef.current["SSRM_OPPICD"];
        data["fromSyoyu"] = entrydataRef.current["SSR_SIIREMOTO"];
        data["toSyoyu"] = entrydataRef.current["SSR_KIKAMOTO"];
        data["syoriKind"] = entrydataRef.current["SSR_SYORIKIND"];
        data["denDate"] = entrydataRef.current["SSR_SIIREBI"];
        data["keijoDate"] = entrydataRef.current["SSR_KEIJYODATE"];

        fnc.current.postaxios('TSICom/GetInbkNaibuBaibaiKakeritu',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    entrydataRef.current["INBK_NAIBUBAIBAIKAKERITU"] = data.request;

                    fnc.current.entryrerender();
                    //単価再計算
                    //RecalcExchange();
                    reCalc();
                },
            },
            true
        )
    }
    //
    function getIsuzZeiritu() {
        var data = {};
        data["taxCd"] = entrydataRef.current["SSR_TAXCD"];
        data["ioTaxKbn"] = entrydataRef.current["PDT_CHODATUZEIKBN"];
        data["date"] = entrydataRef.current["SSR_SIIREBI"];

        fnc.current.postaxios('TSICom/GetIsuzZeiritu',
            {
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    entrydataRef.current["ISUZ_ZEIRITU"] = data.request;

                    fnc.current.entryrerender();
                    //単価再計算
                    //RecalcExchange();
                    reCalc();
                },
            },
            true
        )
    }

    // パターン１．当画面が発生元のデータの場合（量産の値引・値増、サンプルの仕入・値引・値増）
    // 　 参照元伝票に製商品発注、製商品仕入が選択可能
    // ＜判定条件＞
    // 　[画面項目２] OR　[画面項目３]以外
    //
    // パターン２．当画面以外が発生元のデータの場合（自動仕入計上されたデータ）
    // ＜判定条件＞
    // 　仕入種別[SSR_SIIREKIND] = "0:量産" AND
    // 　登録PCID[SSR_INPCID]　＝ "BAT0002"　OR "BAT0003"　OR "BAT0004"
    // 　OR
    // 　仕入種別[SSR_SIIREKIND] = "0:量産" AND
    // 処理種別[SSR_SYORIKIND] = ”03:値引” OR "04:値増" AND
    // 　参照元[SSR_SanMotoDenKbn] = "" AND
    // 　Invoice№[SSR_INVOICENO] ＝ ””
    //
    // パターン３．＜参照元：“サンプル納品明細”＞の場合（【W_ZSR】で確定されたもの [ ZSR_FixFlg=1 ] のみ対象）
    // 参照元伝票に製商品発注、製商品仕入が選択可能
    // ＜判定条件＞
    // 　仕入種別[SSR_SIIREKIND] = "1:サンプル" AND
    // 　参照元[SSR_SanMotoDenKbn] = "4:サンプル納品明細" AND
    // 原材料サンプル仕入データ【W_ZSR】確定フラグ[ZSR_FixFlg=1]
    function getPattern() {
        let data = entrydataRef.current;

        var siireKind = data["SSR_SIIREKIND"];
        var syoriKind = data["SSR_SYORIKIND"];
        var sanMotoDenKbn = data["SSR_SANMOTODENKBN"];
        var sansyoDenNo = data["SSR_SANSYODENNO"];
        var invoiceNo = data["SSR_INVOICENO"];
        var inPcId = data["SSR_INPCID"];

        var pattern = 1;

        if (siireKind == "0" && (inPcId == "BAT0002" || inPcId == "BAT0003" || inPcId == "BAT0004")) {
            pattern = 2;
        }
        if (siireKind == "0" && (syoriKind == "03" || syoriKind == "04") && !sanMotoDenKbn && !invoiceNo) {
            pattern = 2;
        }
        if (siireKind == "1" && sanMotoDenKbn == "4") {
            // ※ 参照元をサンプル納品明細にした時点でパターン３確定
            pattern = 3;
        }
        return pattern;
    }
    function setOption(options, columnId) {
        settextfields(prev =>
            prev.map(item =>
                item.columnid === columnId
                    ? { ...item, options }
                    : item
            )
        );
    }
    function init() {
        let disable = [];
        let enable = [];

        enable.push("SSR_SIIREKBN");
        enable.push("SSR_SIIREKBN2");
        enable.push("SSR_SYORIKIND");
        enable.push("SSR_SANMOTODENKBN");
        enable.push("SSR_SANSYODENNO");
        enable.push("SSR_SIIREBI");
        enable.push("SSR_KEIJYODATE");
        enable.push("SSR_SIIREMOTO");
        enable.push("SSR_KIKAMOTO");
        enable.push("SSR_SOKOKBN");
        enable.push("SSR_SOKOCD");
        enable.push("SSR_SIIRESAKICD");

        disable.push("SSR_NEBIKINEMASI");
        disable.push("SSR_INVOICENO");
        disable.push("SSR_INVOICEEDA");
        disable.push("SSR_SHOKUFLG");

        isEditable(disable, enable);

        showpanel('0', '104', false);

        let data = entrydataRef.current;

        const excludeKeys = new Set([
            "rowid",
            "DENKBN",
            "SSR_SYNFLG1",
            "SSR_KIKANCP_FLG",
            "SSR_CREATEAC",
            "SSR_CREATEDATE",
            "SSR_UPDATEAC",
            "SSR_UPDATE",
            "SSR_TEISEIKBN",
            "SSR_DENNO",
            "SSR_SIIREKIND",
            "SSR_JYUTAKUKBN",
            "SSR_INPUTTANTOCD",
            "SSR_SIIRETANTOCD",
            "SSR_CUR"
        ]);
        Object.keys(data).forEach(key => {
            if (!excludeKeys.has(key)) {
                data[key] = "";
            }
        });
        data["SSR_SHOKUFLG"] = '0';

        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }
    }
    function initLoad() {
        let data = entrydataRef.current;

        let disable = [];
        let enable = [];

        let pattern = getPattern();

        if (pattern === 1) {
            // 仕入種別
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SIIREKIND");
            } else {
                enable.push("SSR_SIIREKIND");
            }
            // 仕入区分１
            enable.push("SSR_SIIREKBN");
            // 仕入区分２
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SIIREKBN2");
            } else {
                enable.push("SSR_SIIREKBN2");
            }
            // 処理種別
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SYORIKIND");
            } else {
                enable.push("SSR_SYORIKIND");
            }
            // 参照元
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SANMOTODENKBN");
            } else {
                enable.push("SSR_SANMOTODENKBN");
            }
            // 参照元(伝票番号)
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SANSYODENNO");
            } else {
                enable.push("SSR_SANSYODENNO");
            }
            // 商品区分
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SHOHINKBN");
            } else {
                enable.push("SSR_SHOHINKBN");
            }
            // 仕入日
            enable.push("SSR_SIIREBI");
            // 計上日
            enable.push("SSR_KEIJYODATE");
            // 受託品
            // 発注元
            if (data["SSR_SANSYODENNO"]) {
                if (data[""] === "1") {
                    enable.push("SSR_SIIREMOTO");
                } else {
                    disable.push("SSR_SIIREMOTO");
                }
            } else {
                enable.push("SSR_SIIREMOTO");
            }
            // 企画元
            if (data["SSR_SANSYODENNO"]) {
                if (data[""] === "1") {
                    enable.push("SSR_KIKAMOTO");
                } else {
                    disable.push("SSR_KIKAMOTO");
                }
            } else {
                enable.push("SSR_KIKAMOTO");
            }
            // 入力担当者
            enable.push("SSR_INPUTTANTOCD");
            // 仕入担当者
            enable.push("SSR_SIIRETANTOCD");
            // 海外区分
            // 通貨区分
            // 通貨単位
            // レート
            // 在庫場所区分
            enable.push("SSR_SOKOKBN");
            // 在庫場所
            enable.push("SSR_SOKOCD");
            // 値引・値増種類
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_NEBIKINEMASI");
            } else {
                enable.push("SSR_NEBIKINEMASI");
            }
            // 税分類
            // 仕入先
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SIIRESAKICD");
            } else {
                enable.push("SSR_SIIRESAKICD");
            }
            // InvoiceNo.
            // Invoice枝番
            // 諸口区分
            // 仕入先担当部門
            // 仕入先担当者
            // 先方伝票番号
            // 摘要
        }
        if (pattern === 2) {
            // 仕入種別
            disable.push("SSR_SIIREKIND");
            // 仕入区分１
            if (data["SSR_SHOHINKBN"] === "01") {
                enable.push("SSR_SIIREKBN");
            } else {
                disable.push("SSR_SIIREKBN");
            }
            // 仕入区分２
            disable.push("SSR_SIIREKBN2");
            // 処理種別
            disable.push("SSR_SYORIKIND");
            // 参照元
            disable.push("SSR_SANMOTODENKBN");
            // 参照元(伝票番号)
            disable.push("SSR_SANSYODENNO");
            // 商品区分
            disable.push("SSR_SHOHINKBN");
            // 仕入日
            disable.push("SSR_SIIREBI");
            // 計上日
            disable.push("SSR_KEIJYODATE");
            // 受託品
            // 発注元
            disable.push("SSR_SIIREMOTO");
            // 企画元
            disable.push("SSR_KIKAMOTO");
            // 入力担当者
            disable.push("SSR_INPUTTANTOCD");
            // 仕入担当者
            disable.push("SSR_SIIRETANTOCD");
            // 海外区分
            // 通貨区分
            // 通貨単位
            // レート
            // 在庫場所区分
            disable.push("SSR_SOKOKBN");
            // 在庫場所
            disable.push("SSR_SOKOCD");
            // 値引・値増種類
            disable.push("SSR_NEBIKINEMASI");
            // 税分類
            // 仕入先
            disable.push("SSR_SIIRESAKICD");
            // InvoiceNo.
            disable.push("SSR_INVOICENO");
            // Invoice枝番
            disable.push("SSR_INVOICEEDA");
            // 諸口区分
            // 仕入先担当部門
            // 仕入先担当者
            // 先方伝票番号
            // 摘要
        }
        if (pattern === 3) {
            // 仕入種別
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SIIREKIND");
            } else {
                enable.push("SSR_SIIREKIND");
            }
            // 仕入区分１
            disable.push("SSR_SIIREKBN");
            // 仕入区分２
            disable.push("SSR_SIIREKBN2");
            // 処理種別
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SYORIKIND");
            } else {
                enable.push("SSR_SYORIKIND");
            }
            // 参照元
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SANMOTODENKBN");
            } else {
                enable.push("SSR_SANMOTODENKBN");
            }
            // 参照元(伝票番号)
            if (data["SSR_SANSYODENNO"]) {
                disable.push("SSR_SANSYODENNO");
            } else {
                enable.push("SSR_SANSYODENNO");
            }
            // 商品区分
            disable.push("SSR_SHOHINKBN");
            // 仕入日
            disable.push("SSR_SIIREBI");
            // 計上日
            enable.push("SSR_KEIJYODATE");
            // 受託品
            // 発注元
            disable.push("SSR_SIIREMOTO");
            // 企画元
            disable.push("SSR_KIKAMOTO");
            // 入力担当者
            enable.push("SSR_INPUTTANTOCD");
            // 仕入担当者
            enable.push("SSR_SIIRETANTOCD");
            // 海外区分
            // 通貨区分
            // 通貨単位
            // レート
            // 在庫場所区分
            enable.push("SSR_SOKOKBN");
            // 在庫場所
            enable.push("SSR_SOKOCD");
            // 値引・値増種類
            disable.push("SSR_NEBIKINEMASI");
            // 税分類
            // 仕入先
            disable.push("SSR_SIIRESAKICD");
            // InvoiceNo.
            // Invoice枝番
            // 諸口区分
            // 仕入先担当部門
            // 仕入先担当者
            // 先方伝票番号
            // 摘要

        }
        isEditable(disable, enable);

        setSanMotoDenKbnList()
    }
    function setSanMotoDenKbnList() {
        const options = [];

        let data = entrydataRef.current;

        let pattern = getPattern();

        var siireKind = data["SSR_SIIREKIND"];
        var syoriKind = data["SSR_SYORIKIND"];

        if (pattern === 2) {
            options.push({ code: "8", name: "売仕売上" });
            options.push({ code: "9", name: "仕入入荷実績" });
        } else {
            if (syoriKind === "03" || syoriKind === "04") {
                options.push({ code: "2", name: "製商品仕入" });
            } else {
                if (siireKind === "1" && syoriKind === "01") {
                    options.push({ code: "1", name: "製商品発注" });
                    options.push({ code: "4", name: "サンプル納品明細" });
                }
            }
        }
        setOption(options, "SSR_SANMOTODENKBN");
    }
    function setSokoKbnList() {
        let data = entrydataRef.current;

        let pattern = getPattern();

        const options = [];

        if (pattern === 3) {
            options.push({ code: "6", name: "本部" });
        } else {
            options.push({ code: "4", name: "店舗" });
            options.push({ code: "6", name: "本部" });
        }
        setOption(options, "SSR_SOKOKBN");

        if (pattern === 3) {
            data["SSR_SOKOKBN"] = "6";
        }
    }
    //
    function changeEditable(id, value) {

        let pattern = getPattern();

        let data = entrydataRef.current;

        var siireKind = data["SSR_SIIREKIND"];
        var syoriKind = data["SSR_SYORIKIND"];
        var sanMotoDenKbn = data["SSR_SANMOTODENKBN"];
        var sansyoDenNo = data["SSR_SANSYODENNO"];

        let disable = [];
        let enable = [];
        // 仕入種別
        if (id === "SSR_SIIREKIND") {
            if (value === "0") {
                // 量産
                enable.push("SSR_BUBIKIFLG");
            } else if (value === "1") {
                // サンプル
                disable.push("SSR_BUBIKIFLG");
            }
        }
        // 参照元
        if (id === "SSR_SANMOTODENKBN") {
            if (value === "1") {
                enable.push("SSR_SIIREKBN");
                enable.push("SSR_SIIREBI");
                enable.push("SSR_SIIREMOTO");
                enable.push("SSR_KIKAMOTO");
                disable.push("SSR_SIIRESAKICD");
            } else if (value === "2") {
                disable.push("SSR_SIIREKBN2");
                disable.push("SSR_SHOHINKBN");
                disable.push("SSR_SIIREMOTO");
                disable.push("SSR_KIKAMOTO");
                disable.push("SSR_SIIRESAKICD");
            } else if (value === "4") {
                disable.push("SSR_SIIREKBN");
                disable.push("SSR_SIIREKBN2");
                disable.push("SSR_SHOHINKBN");
                disable.push("SSR_SIIREBI");
                disable.push("SSR_SIIREMOTO");
                disable.push("SSR_KIKAMOTO");
                disable.push("SSR_SIIRESAKICD");
                disable.push("SSR_SOKOKBN");
            } else {
                enable.push("SSR_SIIREKBN");
                enable.push("SSR_SIIREKBN2");
                enable.push("SSR_SIIREBI");
                enable.push("SSR_SIIREMOTO");
                enable.push("SSR_KIKAMOTO");
                enable.push("SSR_SIIRESAKICD");
                enable.push("SSR_SHOHINKBN");
                enable.push("SSR_SOKOKBN");
            }

            // // 商品区分
            // if (!value) {
            //     enable.push("SSR_SIIREKBN2");
            //     enable.push("SSR_SHOHINKBN");
            // } else {
            //     disable.push("SSR_SIIREKBN2");
            //     disable.push("SSR_SHOHINKBN");
            // }
        }
        // 参照元伝票番号
        if (id === "SSR_SANSYODENNO") {
            if (pattern === 3) {

            }
        }
        isEditable(disable, enable);
    }
    // 編集可否
    function isEditable(disableIds, enableIds) {
        if (disableIds.length > 0) {
            disableIds.forEach(function (id) {
                changeCellLock(id, true);
            });
        }
        if (enableIds.length > 0) {
            enableIds.forEach(function (id) {
                changeCellLock(id, false);
            });
        }
    }
    // 編集ロック
    function changeCellLock(columnid, locked) {
        const updateColumns = (fields) => {
            if (isEmpty(fields)) {
                return fields;
            }
            const idx = fields.findIndex(e => e.columnid === columnid);
            if (idx === -1 || fields[idx].readonly === true) {
                return fields;
            }
            const newfields = DeepCopy(fields);
            newfields[idx].locked = locked;
            return newfields;
        };
        settextfieldsall(prev => updateColumns(prev));
        settextfields(prev => updateColumns(prev));
    }
    // 仕入先情報取得
    function getSuppliersInfo(mode) {
        var data = {};
        data["torcd"] = entrydataRef.current["SSR_SIIRESAKICD"];

        if (isEmpty(data["torcd"])) {
            entrydataRef.current["TOR_KUBUN"] = ""
            entrydataRef.current["TOR_CODE"] = ""
            entrydataRef.current["TOR_SUBCODE"] = ""
            entrydataRef.current["TOR_NAME"] = ""
            entrydataRef.current["TOR_NAMERNM"] = ""
            entrydataRef.current["TOR_KAIGAIKBN"] = "0"
            entrydataRef.current["TOR_TUKACD"] = ""
            entrydataRef.current["TOR_SHOKUCHIFLG"] = ""
            entrydataRef.current["TOR_SUBCDBUMONNM"] = ""
            entrydataRef.current["TOR_SUBCDTANTONM"] = ""
            return;
        }
        fnc.current.postaxios('ProdPurchaseV/GetSuppliersInfo',
            {
                type: listoptionRef.current,
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    entrydataRef.current = { ...entrydataRef.current, ...data.rowdata };

                    entrydataRef.current["SSR_KAIGAIKBN"] = data.rowdata['TOR_KAIGAIKBN'];
                    entrydataRef.current["SSR_TSUKATANI"] = data.rowdata['TOR_TUKACD'];
                    entrydataRef.current["SSR_TAXCD"] = data.rowdata['TOR_ZEIBUNRUI'];
                    entrydataRef.current["SSR_SHOKUFLG"] = data.rowdata['TOR_SHOKUCHIFLG'];

                    if (mode === 1) {
                        let disable = [];
                        let enable = [];

                        if (data.rowdata['TOR_KAIGAIKBN'] === "2") {
                            // InvoiceNo.
                            enable.push("SSR_INVOICENO");
                            // Invoice枝番
                            enable.push("SSR_INVOICEEDA");

                            entrydataRef.current["SSR_INVOICEEDA"] = "0000";
                        } else {
                            // InvoiceNo.
                            disable.push("SSR_INVOICENO");
                            // Invoice枝番
                            disable.push("SSR_INVOICEEDA");

                            entrydataRef.current["SSR_INVOICENO"] = "";
                            entrydataRef.current["SSR_INVOICEEDA"] = "";
                        }
                        isEditable(disable, enable);
                    }
                    showpanel('0', '104', (data.rowdata['TOR_SHOKUCHIFLG'] === '1'));

                    fnc.current.entryrerender();


                    getCurRate();

                    reCalc();
                },
            },
            true
        )
    }
    // 品番情報取得
    function getMPdtInfo(rowdata, oppiCd, shnCd) {
        var data = {};

        if (oppiCd) {
            data["oppiCd"] = oppiCd;
        }
        if (shnCd) {
            data["shnCd"] = shnCd;
        }

        if (!oppiCd && !shnCd) {
            rowdata["PDT_OPPICD"] = "";
            rowdata["PDT_SYOHINCD"] = "";
            rowdata["PDT_BRDCODE"] = "";
            rowdata["PDT_BRDCODE_cd"] = "";
            rowdata["PDT_BRDCODE_nm"] = "";
            rowdata["PDT_HINMEINM"] = "";
            rowdata["PDT_CHODATUZEIKBN"] = "";
            rowdata["PDT_MAKERHINBAN"] = "";
            rowdata["PDT_PATTERNNO1"] = "";
            rowdata["PDT_TANNI"] = "";
            rowdata["PDT_TANNI_cd"] = "";
            rowdata["PDT_TANNI_nm"] = "";
            rowdata["PDT_PRICE"] = 0;
            return;
        }
        fnc.current.postaxios('ProdPurchaseV/GetMPdtInfo',
            {
                type: listoptionRef.current,
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);

                    // entrydataRef.current = { ...entrydataRef.current, ...data.rowdata };

                    // rowdata = { ...rowdata, ...data.rowdata };

                    rowdata["SSRM_OPPICD"] = data.rowdata["PDT_OPPICD"];
                    rowdata["PDT_SYOHINCD"] = data.rowdata["PDT_SYOHINCD"];
                    rowdata["SSRM_BRDCD"] = data.rowdata["PDT_BRDCODE"];
                    rowdata["SSRM_BRDCD_cd"] = data.rowdata["PDT_BRDCODE"];
                    rowdata["SSRM_BRDCD_nm"] = data.rowdata["PDT_BRDCODE_nm"];
                    rowdata["PDT_MAKERHINBAN"] = data.rowdata["PDT_MAKERHINBAN"];
                    rowdata["PDT_PATTERNNO1"] = data.rowdata["PDT_PATTERNNO1"]; 
                    rowdata["SSRM_TANI"] = data.rowdata["PDT_TANNI"];
                    rowdata["SSRM_TANI_cd"] = data.rowdata["PDT_TANNI"];
                    rowdata["SSRM_TANI_nm"] = data.rowdata["PDT_TANNI_nm"];
                    rowdata["SSRM_COLORCD"] = "";
                    rowdata["SSRM_COLORNM"] = "";
                    rowdata["SSRM_SIZECD"] = "";
                    rowdata["SSRM_SIZENM"] = "";
                    rowdata["SSRM_KIND"] = "1";
                    rowdata["PDT_CHODATUZEIKBN"] = data.rowdata["PDT_CHODATUZEIKBN"];

                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));

                    reCalc();
                },
            },
            true
        )
    }
    // 品番情報取得
    function getMPdtcInfo(rowdata) {
        var data = {};

        data["oppiCd"] = rowdata["SSRM_OPPICD"];
        data["colorCd"] = rowdata["SSRM_COLORCD"];
        data["sizeCd"] = rowdata["SSRM_SIZECD"];

        if (!data["oppiCd"]) {
            rowdata["PDTC_OPPICD"] = "";
            rowdata["PDTC_COLORCD"] = "";
            rowdata["PDTC_SIZECD"] = "";
            rowdata["PDTC_COLORNM"] = "";
            rowdata["PDTC_PRICE"] = 0;
            rowdata["SZE_SIZENM"] = "";
            return;
        }
        fnc.current.postaxios('ProdPurchaseV/GetMPdtcInfo',
            {
                type: listoptionRef.current,
                controller: controller,
                data: data
            },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);

                    //entrydataRef.current = { ...entrydataRef.current, ...data.rowdata };

                    //SetGridData(G_id.MEI, data.rowdata);

                    rowdata["SSRM_COLORNM"] = data.rowdata["PDTC_COLORNM"];
                    rowdata["SSRM_SIZENM"] = data.rowdata["SZE_SIZENM"];
                    rowdata["PDTC_PRICE"] = data.rowdata["PDTC_PRICE"];

                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));

                    reCalc();
                },
            },
            true
        )
    }
    // D_SHD 取得
    function getDShd(value) {
        let data = entrydataRef.current;

        let values = [];
        values.push(value);
        let others = {
            SSR_SYORIKIND: data["SSR_SYORIKIND"],
            SSR_SIIREBI: data["SSR_SIIREBI"],
            SSR_KEIJYODATE: data["SSR_KEIJYODATE"],
            SSR_SIIREMOTO: data["SSR_SIIREMOTO"],
            SSR_KIKAMOTO: data["SSR_KIKAMOTO"],
        };
        fnc.current.postaxios('ProdPurchaseV/GetDShd', { "keys": values, "others": others },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    entrydataRef.current = { ...entrydataRef.current, ...data.data };

                    // fnc.current.entryrerender();

                    SetGridData(G_id.MEI, data.rowdata);

                    getSuppliersInfo(0);

                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));
                },
                errmsg: "処理に失敗しました"
            }
        )
    }
    // D_SSR 取得
    function getDSsr(value) {
        let values = [];
        values.push(value);
        let others = {
        };
        fnc.current.postaxios('ProdPurchaseV/GetDSsr', { "keys": values, "others": others },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    entrydataRef.current = { ...entrydataRef.current, ...data.data };

                    // fnc.current.entryrerender();

                    SetGridData(G_id.MEI, data.rowdata);

                    getSuppliersInfo(0);

                    fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));
                },
                errmsg: "処理に失敗しました"
            }
        )
    }
    // W_SSR 取得
    function getWSsr(value) {
        let values = [];
        values.push(value);
        let others = {
        };
        fnc.current.postaxios('ProdPurchaseV/GetWSsr', { "keys": values, "others": others },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    entrydataRef.current = { ...entrydataRef.current, ...data.data };

                    SetGridData(G_id.MEI, data.rowdata);

                    getSuppliersInfo(0);

                    //fnc.current.rerenderGrid(fnc.current.GridID(G_id.MEI));

                    //fnc.current.entryrerender();

                    rerender();

                },
                errmsg: "処理に失敗しました"
            }
        )
    }
    function reCalc() {
        let panel = G_id.MEI;
        let data = GridData(panel);
        if (isEmpty(data)) return;

        setTotal(panel, data);

        fnc.current.rerenderGrid(panel);
    }
    //
    function calcTotal(id, data) {
        if (id !== G_id.MEI) {
            return null;
        }
        if (isEmpty(entrydataRef.current)) {
            return null;
        }
        // qty: 仕入数
        // tax: 消費税
        // not: 税抜き
        // gai: 外貨
        // amt: 税込
        let total = { qty: 0, tax: 0, not: 0, gai: 0, amt: 0 };

        for (let i = 0; i < data.length; i++) {
            total.qty += NumConv(data[i]["SSRM_SIIRESU"]);
            //total.tax += NumConv(data[i]["SSRM_SIIRESU"]);
            total.not += NumConv(data[i]["SSRM_SIIREKINGAKU"]);
            total.gai += NumConv(data[i]["SSRM_SIIREKINGAKUF"]);
            //total.amt += total.qty * NumConv(data[i]["SSRM_TANKA"]);
        }
        return total;
    }
    //
    function setTotal(id, data) {
        var total = calcTotal(id, data);
        if (total === null) return;

        SetGridData({ id: G_id.TOTAL }, [{ rowid: "TOTAL", grip: "計", "SSR_QTY_T": total.qty, "SSR_NOT_T": total.not, "SSR_GAI_T": total.gai }]);

        fnc.current.rerenderGrid(G_id.TOTAL);

        // let rowNode = GridApi("T" + id).getRowNode("TOTAL");
        // if (!isEmpty(rowNode)) {
        //     rowNode.setDataValue('SSR_QTY_T', total.qty);
        //     rowNode.setDataValue('SSR_NOT_T', total.not);
        //     rowNode.setDataValue('SSR_GAI_T', total.gai);

        //     // if (entrydataRef.current["TOR_TUKACD"] === "JPY") {
        //     //     rowNode.setDataValue('SSR_AMT_T', total.amt);
        //     // } else {
        //     //     rowNode.setDataValue('SSR_AMT_T', total.amtf);
        //     // }
        // }
    }
    
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {

        // if (status === "INSERT") {
        //     //自テーブル以外編集不可
        //     if (tabvalue !== params.colDef.colinfo.type) return false;
        // }
        return edit;
    }
    //明細編集セル制御
    function RowlockCell(params, edit, status, tabvalue) {
        let pattern = getPattern();

        if (pattern === 1) {
            let data = entrydataRef.current;

            var siireKind = data["SSR_SIIREKIND"];
            var syoriKind = data["SSR_SYORIKIND"];
            var sanMotoDenKbn = data["SSR_SANMOTODENKBN"];
            var sansyoDenNo = data["SSR_SANSYODENNO"];
            var tukaCd = data["TOR_TUKACD"];

            if (sanMotoDenKbn === "1") {

                if (params.colDef.colId === "SSRM_OPPICD" || params.colDef.colId === "PDT_SYOHINCD") {
                    return false;
                }
                if (params.colDef.colId === "SSRM_COLORCD" || params.colDef.colId === "SSRM_SIZECD") {
                    return false;
                }
                if (params.colDef.colId === "SSRM_HACHUSU") {
                    return false;
                }
                if (params.colDef.colId === "SSRM_TANKA") {
                    if (tukaCd !== 'JPY') {
                        return false;
                    }
                }
                if (params.colDef.colId === "SSRM_TANKAF") {
                    if (tukaCd === 'JPY') {
                        return false;
                    }
                }
            } else {
                if (params.colDef.colId === "SSRM_OPPICD" || params.colDef.colId === "PDT_SYOHINCD") {
                    return true;
                }
                if (params.colDef.colId === "SSRM_COLORCD" || params.colDef.colId === "SSRM_SIZECD") {
                    if (!params.data["SSRM_OPPICD"]) {
                        return false;
                    } else {
                        return true;
                    }
                }
                if (params.colDef.colId === "SSRM_TANKA") {
                    if (tukaCd === 'JPY') {
                        return true;
                    }
                }
                if (params.colDef.colId === "SSRM_TANKAF") {
                    if (tukaCd !== 'JPY') {
                        return true;
                    }
                }
            }
            if (params.colDef.colId === "SSRM_SIIRESU") {
                if (syoriKind == "01") {
                    return true;
                }
                if (syoriKind == "03" || syoriKind == "04") {
                    return false;
                }
            }
            
            if (params.colDef.colId === "SSRM_URITANKA") {
                if (siireKind === "1" && syoriKind == "01") {
                    return true;
                } else {
                    return false;
                }
            }
            if (params.colDef.colId === "SSRM_BIKO") {
                return true;
            }
        }
        if (pattern === 2) {
            if (params.colDef.colId === "SSRM_BIKO") {
                return true;
            }
            return false;
        }
        if (pattern === 3) {
            if (params.colDef.colId === "SSRM_BIKO") {
                return true;
            }
            return false;
        }
        return false;
    }

    //idに対する合計行が存在するか
    function existTotal(id) {
        return gridlist.some(e => e.id === "T" + id);
    }

    //idに対する種別を取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }


    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                return (
                    <React.Fragment>
                        <EntryGridAr
                            id={fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={(e) => ChangeRowValue(e, props.panel)}
                            RowValueChanged={(colid, rows) => RowValueChanged(colid, rows, props.panel)}
                            RemoveRow={(e) => RowDataChanged(e, props.panel)}
                            formid={formid}
                            panel={props.panel}
                            lockcell={RowlockCell}
                        />
                        {!existTotal(props.panel.id) ? null :
                            <EntryGridAr
                                id={fnc.current.GridID("T" + props.panel.id)}
                                entrydataRef={entrydataRef}
                                dataRef={griddataRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columnRef={gridcolRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columninfo={columninfo}
                                columns={columns}
                                fnc={fnc}
                                onFirstDataRendered={onFirstDataRendered}
                                formid={formid}
                                panel={props.panel}
                                total={true}
                                totaltype={tabletype("T" + props.panel.id)}
                            />
                        }
                    </React.Fragment>
                );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={() => storeRowData(props.panel)}
                        panel={props.panel}
                    />
                );
            }
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        switch (listoptionRef.current) {
            case "0":
                if (!SSR.includes(p.type)) return true;
                break;
            case "1":
                if (!SSH.includes(p.type)) return true;
                break;
            case "2":
                if (!SSU.includes(p.type)) return true;
                break;
            case "3":
                if (!SNS.includes(p.type)) return true;
                break;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                usecondition={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} hidden={panelhidden}></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.5,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};

